import { render, staticRenderFns } from "./settings-section-header.vue?vue&type=template&id=1bcec9b3&scoped=true&"
import script from "./settings-section-header.vue?vue&type=script&lang=js&"
export * from "./settings-section-header.vue?vue&type=script&lang=js&"
import style0 from "./settings-section-header.vue?vue&type=style&index=0&id=1bcec9b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcec9b3",
  null
  
)

export default component.exports